import { ManifoldTabEnum } from 'src/researcher/types/toolpane';
import { ProjectStatusEnum } from 'src/researcher/types/project';
import { MinimumWebSearchLength } from './common.constants';

export const ManifoldTabTooltipText = {
  [ManifoldTabEnum.RESEARCH]: 'Search the web to find content, statistics, and more',
  [ManifoldTabEnum.NOTEBOOK]: 'Use this space to take notes',
  [ManifoldTabEnum.CITATIONS]: 'Easily manage citations for your content',
};

export const ProjectStatusMsg = {
  ONLINE: 'Ready to save your work',
  OFFLINE: 'Seems you are offline',
  [ProjectStatusEnum.IDLE]: 'Get started by writing something!',
  [ProjectStatusEnum.CREATED]: 'Start writing!',
  [ProjectStatusEnum.CREATING]: 'Setting up project for you...',
  [ProjectStatusEnum.UNSAVED]: 'Unsaved',
  [ProjectStatusEnum.SAVING]: 'Saving...',
  [ProjectStatusEnum.SAVED]: 'Saved',
  [ProjectStatusEnum.RESTORING]: 'Restoring your previous work...',
  [ProjectStatusEnum.RESTORED]: 'Start writing!',
};

export const FixAllGrammarErrorMsg = 'Fix all grammar errors';
export const VoiceTranscriptTooltipMsg = 'Please allow microphone permission';
export const OpenProjectDialogMsg = 'Open projects';
export const FeedbackTooltip = 'Give Feedback';

// Toaster ------------------------------------------
// project dialog message
export const NoBookmarksMsg =
  'No saved bookmarks were found. Bookmarks can be created from search results.';
export const ErrorRestoringProjectMsg = 'Something went wrong while restoring project';
export const ErrorProjectIdNotValidMsg = "Project doesn't exist or is invalid";
export const ErrorCreatingProjectMsg = 'Something went wrong while creating project';
export const ErrorLoadingProjectListMsg = 'Something went wrong while loading project';
export const ErrorDownloadingProjectMsg = 'Something went wrong while exporting project';
export const ErrorDeletingProjectMsg = 'Something went wrong while while deleting project';
export const ErrorUnDeletingProject = 'Something went wrong while restoring project';

export const ClickPullSourceToAccessFeatureMsg = 'Click the explore button to access features';
export const StartByPullingSourceMsg = 'Please start by clicking on Explore button';
export const WaitingForSourcePullMsg = 'Please wait while trying to fetch this result';
export const NoHighlightMsg = 'No highlights available for this source';
export const NoTopicMsg = 'No topics available for this source';
export const ErrorUnableToPullSource = 'Unable to fetch data for this result';
export const NoContentSourceMsg = "This result doesn't have any content to show";
export const PullSourceMsg = 'Click to access features';

// context-menu
export const SelectSomeMoreToPphrMsg = 'Select more text to paraphrase';
export const SelectSomeMoreToSumMsg = 'Select more text to summarize';
export const SelectSomeMoreToSuggestMsg = 'Type more text to get content suggestions';
export const SelectSomeMoreToSearchMsg = 'Select more text to search';
export const SelectSomemoreToAddCitationMsg = 'Select some more text to insert citation';

//
export const ErrorUploadedFileEmptyMsg =
  'The uploaded document is empty; please upload another one';
export const ErrorYouAreOfflineMsg = 'Seems you are offline';
export const TextCopiedMsg = 'Text copied!';
export const FixedAllGrammarErrorsMsg = 'Fixed all grammar errors';
export const ErrorMicAccessMsg = 'Allow microphone permission to enable dictate';
export const ErrorSearchTermInsufficientMsg = `Please enter at least ${MinimumWebSearchLength} characters`;
export const ErrorSearchingMsg = 'No results found; please change the search terms';
export const ErrorSavingBookmarkMsg = 'Unable to save bookmark; please try again';
export const ErrorSaveNotebookMsg = 'Unable to save notebook content';
export const ErrorGetSuggestionsMsg = 'Unable to get suggestions';
export const NoSuggestionsMsg = 'No suggestions available';
export const UnSupportedFileFormatMsg = 'Unsupported file, please upload a pdf or docx file only';
export const FileSizeTooLargeMsg = 'File too large, please upload a file smaller than 15 MB';
export const UnableToUploadFileMsg =
  'Failed to upload file; please upload a txt, pdf, doc, or docx file only';
export const ErrorDeleteBookmarkMsg = 'Unable to delete bookmark; please, try again';
export const DataUnavailableForPulledMsg = 'Data is unavailable for this result';
export const NoProjectFoundTrashView = 'No projects found. Deleted projects will appear here.';
export const NoProjectFoundAfterDelete =
  'No projects found. Create a new project using the options listed above.';
export const NoProjectFoundOnSearch = 'No projects were found matching your search query.';
// export const EditorTooltips = [
//   'Start writing something amazing!',
//   // 'Begin writing something incredible!',
// ];

// Tooltips
export const PublishedDateTooltip = 'Published on {{publishedDate}}';
export const PublishedAuthorTooltip = 'by {{publishedAuthor}}';

export const ViewStatisticsTooltip = 'View Statistics';
export const ShowGrammarErrorTooltip = 'Show Grammar Errors';
export const HideGrammarErrorTooltip = 'Hide Grammar Errors';
export const GrammarCheckingTooltip = 'Checking Grammar';
export const GrammarErrorTooltip = 'Grammar Error';
export const CopyFullTextTooltip = 'Copy Full Text';
export const BibliographyScrollingButtonTooltip = 'Scroll down to bibliography';
export const PreviousButtonTooltip = 'Previous Paragraph';
export const NextButtonTooltip = 'Next Paragraph';
export const VoiceResetTooltip = 'Reset';
export const VoicePauseTooltip = 'Pause';
export const VoiceResumeTooltip = 'Resume';
export const SearchProjectTooltip = 'Search Project';
export const GridViewTooltip = 'Grid View';
export const ListViewTooltip = 'List View';
export const SortByTooltip = 'Sort by';
export const TrashButtonTooltip = 'Trash';
export const ExportButtonTooltip = 'Export';
export const MoreButtonTooltip = 'More';
export const RestoreButtonTooltip = 'Restore Project';
export const DeleteForeverButtonTooltip = 'Delete Forever';
export const WordCountButtonTooltip = 'View Statistics';
export const DictateButtonTooltip = 'Dictate';
export const RenameProjectTooltip = 'Rename Project';
export const QuillLogoTooltip = 'Co-Writer Home';
export const InsertButtonTooltip = 'Insert to editor';
export const ParaphraserIconTooltip = 'Paraphrase';
export const SummarizerIconTooltip = 'Summarize';
export const ExploreButtonTooltip = 'View this result';
export const KebabMenuTooltip = 'More';
export const WebsiteLinkHoverTooltip = 'Open Website';
export const AddBookmarkButtonTooltip = 'Add Bookmark';
export const RemoveBookmarkButtonTooltip = 'Remove Bookmark';
export const PostBookmarkAddedTooltip = 'Bookmark Added Here';
export const ShowBookmarkTooltip = 'Open Bookmarks';
export const HideBookmarkTooltip = 'Close Bookmarks';
// Tooltip with JSX
// const BibPageTooltip = 'Continue scrolling to view your' + "Works Cited" | "References" | "Bibliography"

// Toasters
export const AlreadyProcessingToasterMessage = 'Already {{processingValue}}'; // {{processingValue}} is replaced with 'processing'/'paraphrasing'/'summarizing'
export const ParaphraserCharTrimToasterMessage =
  'Word limit of {{charLimit}} exceeded, extra words trimmed';
export const AIWriteUnavailabilityToasterMessage = 'Suggest Text will be available in few moments';
export const AIWriteCharLimitToasterMessage = 'Suggest Text needs more text to suggest content';
export const AIWriteRepetitionLimitToasterMessage =
  'Please write more text before using Suggest Text';
export const ReportSourceToasterMessage = 'Source has been reported';
export const ErrorCheckingGrammarToasterMessage = 'Something went wrong while checking grammar';
export const ProjectExportSuccessText = 'Project exported successfully';
export const ProjectDeletedSuccessText = 'Project moved to trash';
export const PasteNoClipboardText = 'No content found in clipboard';
export const EmptyStateParaphraserText = 'Write something to paraphrase';
export const EmptyStateSummarizerText = 'Write something to summarize';
// Typography
// -- modals
export const MoveProjectToTrashModalTitle = 'Move to trash?';
export const MoveProjectToTrashModalContent =
  '"{{projectName}}" will be moved to trash and deleted forever after 30 days.';
export const MoveProjectToTrashModalPrimaryButtonText = 'Move to trash';
export const MoveProjectToTrashModalSecondaryButtonText = 'Cancel';
export const RephraseButtonTooltip = 'Rephrase entire text';
